var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4"},[_c('portal',{attrs:{"to":"crumbs"}},[_vm._v("\n    Training\n  ")]),_vm._v(" "),_c('nuxt-child')],1)}
var staticRenderFns = []

export { render, staticRenderFns }